module.exports = __webpack_public_path__ + "static/img/kx.0b0b7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kx.png
// module id = 4pjQ
// module chunks = 1